import {useSelector} from 'react-redux'
import {useAccommodationTopOffers} from 'components/Accommodation/Offers/useAccommodationTopOffers'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {getRoomOfferAnalyticsContexts} from 'middleware/analytics/selectors'
import {OverlayType} from 'modules/overlay/types'
import {getSearchParameters} from 'modules/sapiSearch/selectors'

import {Offer} from '@vio/core/src/offer/types/offer'
import {roomsToConfigurationObject} from '@vio/core/src/room/business/roomConfiguration'
import {Room} from '@vio/core/src/room/types/room'

type Props = {
  hotelId: string
  room: Room
  offer: Offer
  component: string
}

export const useHandlePriceDetailsClick = ({
  hotelId,
  room,
  offer,
  component
}: Props) => {
  const {offerEntity} = useAccommodationTopOffers({
    hotelId
  })
  const {checkIn, checkOut, rooms, optimizeRooms} =
    useSelector(getSearchParameters)
  const showOverlay = useShowOverlay()
  const analyticsContext = useSelector(state =>
    getRoomOfferAnalyticsContexts(state, offer.id)
  )
  return () => {
    const roomsString = optimizeRooms
      ? offerEntity?.roomsConfig || rooms
      : rooms
    const roomsConfig = roomsToConfigurationObject(roomsString)

    showOverlay({
      type: OverlayType.RoomOfferPriceBreakdownOverlay,
      component,
      analyticsContext,
      params: {
        checkIn,
        checkOut,
        roomsConfig,
        roomName: room.name,
        offer
      }
    })
  }
}
